
import React from 'react';
import { GenericScheduleProps, Schedule22_4_AttachmentsData, AttachmentItem, FormErrorsStep, FormData } from '../../types';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button'; 

const SectionHeader: React.FC<{ title: string }> = ({ title }) => (
  <h4 className="text-md font-semibold text-sky-700 mt-4 mb-2 border-b pb-1">{title}</h4>
);

export const Schedule22_4_Attachments: React.FC<GenericScheduleProps<Schedule22_4_AttachmentsData>> = ({ scheduleData, onChange, errors, t, fullFormData }) => {
  
  const handleAttachmentChange = (index: number, field: keyof AttachmentItem, value: any) => {
    const updatedItems = scheduleData.attachments.map((item, i) => {
      if (i === index) {
        if (field === 'file' && value instanceof File) {
          return { ...item, file: value, fileName: value.name };
        }
        return { ...item, [field]: value };
      }
      return item;
    });
    onChange('attachments', updatedItems);
  };


  return (
    <div className="space-y-4">
      <h3 className="text-lg font-bold text-sky-600">{t('sch22_4_title')}</h3>
      <p className="text-sm text-gray-500">{t('sch22_4_intro_note')}</p>
      
      {scheduleData.attachments.map((item, index) => {
        // Check condition for displaying the attachment
        if (item.condition && !item.condition(fullFormData)) {
          return null; // Don't render if condition not met
        }

        return (
          <div key={item.id} className="p-4 border rounded-md space-y-3 bg-slate-50">
              <label className="block text-sm font-medium text-gray-700">
                {t(item.documentKey as any)} {/* Use the documentKey directly as it's now specific */}
                {item.isMandatory && <span className="text-red-500">*</span>}
              </label>

              <div className="mt-1 flex items-center space-x-3">
                  <label htmlFor={`file-upload-${item.id}`} className="cursor-pointer bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500">
                      <span>{item.fileName ? t('sch22_4_change_file_button') : t('sch22_4_upload_file_button')}</span>
                      <input 
                          id={`file-upload-${item.id}`} 
                          name={`file-upload-${item.id}`} 
                          type="file" 
                          className="sr-only"
                          onChange={(e) => e.target.files && e.target.files[0] && handleAttachmentChange(index, 'file', e.target.files[0])} 
                      />
                  </label>
                  {item.fileName && <span className="text-sm text-gray-500">{item.fileName}</span>}
              </div>
              {(errors?.attachments as FormErrorsStep[] | undefined)?.[index]?.file && <p className="text-xs text-red-500 mt-1">{(errors?.attachments as FormErrorsStep[])?.[index]?.file as string}</p>}


              {!item.file && item.isMandatory && (
                  <Input 
                      label={t('sch22_4_reason_not_provided_label')} 
                      type="text" 
                      id={`reason-${item.id}`} 
                      value={item.reasonIfNotProvided || ''} 
                      onChange={(e) => handleAttachmentChange(index, 'reasonIfNotProvided', e.target.value)}
                      error={(errors?.attachments as FormErrorsStep[])?.[index]?.reasonIfNotProvided as string}
                      placeholder={t('sch22_4_reason_placeholder')}
                  />
              )}
              {(errors?.attachments as FormErrorsStep[] | undefined)?.[index]?.reasonIfNotProvided && !item.reasonIfNotProvided && item.isMandatory && !item.file &&
                <p className="text-xs text-red-500 mt-1">{(errors?.attachments as FormErrorsStep[])?.[index]?.reasonIfNotProvided as string}</p>
              }
          </div>
        );
      })}
       <p className="text-xs text-gray-500 mt-4">{t('sch22_4_maintenance_note')}</p>
    </div>
  );
};
